import { render, staticRenderFns } from "./storeDoc.vue?vue&type=template&id=3fb2b1e0&scoped=true"
import script from "./storeDoc.vue?vue&type=script&lang=js"
export * from "./storeDoc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb2b1e0",
  null
  
)

export default component.exports